/* =========================================================================
   MapleWeld — live "Open now / Closed" badge.

   Reads the opening schedule from a data attribute on the element and works
   out, IN THE SHOP'S OWN TIMEZONE, whether the counter is open right now.
   A visitor in Vancouver or Halifax sees Toronto's status, not their own.

   This is NOT a Google Business Profile feed — that needs a billed, key-
   authenticated server call and a key cannot be safely shipped in theme JS.
   The schedule is edited in the theme editor; the badge below is what makes
   it feel live.

   Fails silent: if anything at all goes wrong the badge stays hidden and the
   plain hours line beside it still reads correctly.
   ========================================================================= */
(function () {
  'use strict';

  var DAY_INDEX = {
    sun: 0, sunday: 0,
    mon: 1, monday: 1,
    tue: 2, tues: 2, tuesday: 2,
    wed: 3, weds: 3, wednesday: 3,
    thu: 4, thur: 4, thurs: 4, thursday: 4,
    fri: 5, friday: 5,
    sat: 6, saturday: 6
  };
  var DAY_SHORT = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function toMinutes(t) {
    var m = /^(\d{1,2}):(\d{2})$/.exec(String(t).trim());
    if (!m) return null;
    var h = parseInt(m[1], 10), mi = parseInt(m[2], 10);
    if (h < 0 || h > 24 || mi < 0 || mi > 59) return null;
    return h * 60 + mi;
  }

  /* "Mon | 08:00 | 16:30" per line → { 1: [480, 990], ... } */
  function parseSchedule(text) {
    var out = {};
    String(text || '').split(/[\r\n]+/).forEach(function (line) {
      var p = line.split('|');
      if (p.length < 3) return;
      var day = DAY_INDEX[p[0].trim().toLowerCase()];
      if (day === undefined) return;
      var open = toMinutes(p[1]), close = toMinutes(p[2]);
      if (open === null || close === null || close <= open) return;
      out[day] = [open, close];
    });
    return out;
  }

  /* Current weekday + minutes-past-midnight in the shop's timezone. */
  function nowInZone(tz) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });

    var day = DAY_INDEX[String(parts.weekday || '').toLowerCase()];
    var h = parseInt(parts.hour, 10);
    if (h === 24) h = 0;                      // some engines report 24 for midnight
    var mi = parseInt(parts.minute, 10);
    if (day === undefined || isNaN(h) || isNaN(mi)) return null;
    return { day: day, mins: h * 60 + mi };
  }

  function clock(mins) {
    var h = Math.floor(mins / 60) % 24, mi = mins % 60;
    var suffix = h < 12 ? 'am' : 'pm';
    var hh = h % 12; if (hh === 0) hh = 12;
    return hh + (mi ? ':' + (mi < 10 ? '0' + mi : mi) : '') + suffix;
  }

  function status(schedule, now) {
    var today = schedule[now.day];

    if (today && now.mins >= today[0] && now.mins < today[1]) {
      return { open: true, text: 'Open now · closes ' + clock(today[1]) };
    }
    if (today && now.mins < today[0]) {
      return { open: false, text: 'Closed · opens ' + clock(today[0]) };
    }
    for (var i = 1; i <= 7; i++) {
      var d = (now.day + i) % 7;
      if (schedule[d]) {
        var when = i === 1 ? 'tomorrow' : DAY_SHORT[d];
        return { open: false, text: 'Closed · opens ' + when + ' ' + clock(schedule[d][0]) };
      }
    }
    return null;
  }

  function paint(el) {
    try {
      var schedule = parseSchedule(el.getAttribute('data-schedule'));
      if (!Object.keys(schedule).length) return;

      var tz = el.getAttribute('data-tz') || 'America/Toronto';
      var now = nowInZone(tz);
      if (!now) return;

      var s = status(schedule, now);
      if (!s) return;

      el.textContent = s.text;
      el.classList.remove('mwh-open--open', 'mwh-open--shut');
      el.classList.add(s.open ? 'mwh-open--open' : 'mwh-open--shut');
      el.hidden = false;
    } catch (e) {
      el.hidden = true;                        // plain hours line still stands
    }
  }

  function init() {
    var els = document.querySelectorAll('[data-mwh-hours]');
    if (!els.length) return;
    els.forEach(paint);
    // re-check on the minute boundary so a page left open does not go stale
    setInterval(function () { els.forEach(paint); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
